

export const frontMatter = {
	sidebar_position: 2,
	license: 'republish',
	author: 'Jan van Steenbergen',
	origin: 'http://steen.free.fr/interslavic/slovianto2.html',
	description: 'Gender, nouns, adjectives, verbs'
};
export const contentTitle = 'Ниво 2';
export {default as metadata} from '@site/.docusaurus/docusaurus-plugin-content-docs/default/site-i-18-n-bg-docusaurus-plugin-content-docs-current-learn-simple-grammar-level-2-md-743.json'
export const assets = {

};

import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import Tabs from '@theme/Tabs';
import TabItem from '@theme/TabItem';
export const toc = [{
  "value": "Пол",
  "id": "пол",
  "level": 2
}, {
  "value": "Съществителни",
  "id": "съществителни",
  "level": 3
}, {
  "value": "Прилагателни",
  "id": "прилагателни",
  "level": 3
}, {
  "value": "Глаголи",
  "id": "глаголи",
  "level": 2
}, {
  "value": "Сегашно време",
  "id": "сегашно-време",
  "level": 3
}, {
  "value": "Минало време",
  "id": "минало-време",
  "level": 3
}, {
  "value": "Бъдеще време",
  "id": "бъдеще-време",
  "level": 3
}, {
  "value": "Условно",
  "id": "условно",
  "level": 3
}, {
  "value": "Задължително",
  "id": "задължително",
  "level": 3
}, {
  "value": "Глаголът „да бъда“",
  "id": "глаголът-да-бъда",
  "level": 3
}, {
  "value": "Примерен текст",
  "id": "примерен-текст",
  "level": 2
}, {
  "value": "Нашето село",
  "id": "нашето-село",
  "level": 3
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    abbr: "abbr",
    code: "code",
    em: "em",
    h1: "h1",
    h2: "h2",
    h3: "h3",
    header: "header",
    li: "li",
    ol: "ol",
    p: "p",
    span: "span",
    strong: "strong",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  }, {CustomAfterSection, CustomBeforeSection, MDSimpleGrammar1, MDSimpleGrammar2, MDSimpleGrammar3, MDSimpleGrammar4, MDSimpleGrammar5, TransliteratorElement} = _components;
  if (!CustomAfterSection) _missingMdxReference("CustomAfterSection", true);
  if (!CustomBeforeSection) _missingMdxReference("CustomBeforeSection", true);
  if (!MDSimpleGrammar1) _missingMdxReference("MDSimpleGrammar1", true);
  if (!MDSimpleGrammar2) _missingMdxReference("MDSimpleGrammar2", true);
  if (!MDSimpleGrammar3) _missingMdxReference("MDSimpleGrammar3", true);
  if (!MDSimpleGrammar4) _missingMdxReference("MDSimpleGrammar4", true);
  if (!MDSimpleGrammar5) _missingMdxReference("MDSimpleGrammar5", true);
  if (!TransliteratorElement) _missingMdxReference("TransliteratorElement", true);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.header, {
      children: _jsx(_components.h1, {
        id: "ниво-2",
        children: "Ниво 2"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["В ", _jsx(_components.a, {
        href: "/bg/learn/simple-grammar/level-1",
        children: _jsx(_components.strong, {
          children: "Ниво 1"
        })
      }), " сте научили редица форми, които можете да използвате, за да станете разбираеми за славяните на много основно ниво. Този език обаче е много примитивен и изобщо не отдава дължимото на богатството на славянските езици. Така че, ако сте готови на предизвикателството, ето още няколко инструмента, които можете да използвате, за да направите ", _jsx(TransliteratorElement, {
        children: "Slovianto"
      }), " да изглежда и звучи много по-естествено."]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.strong, {
        children: "Ниво 2"
      }), " се различава от ", _jsx(_components.strong, {
        children: "Ниво 1"
      }), " по два начина:"]
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsxs(_components.li, {
        children: ["Ще научите за рода на славянски и как да го използвате в ", _jsx(_components.span, {
          className: "notranslate",
          translate: "no",
          children: "Slovianto"
        }), ","]
      }), "\n", _jsx(_components.li, {
        children: "Ще научите как да спрегате глаголи."
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "пол",
      children: "Пол"
    }), "\n", _jsx(CustomBeforeSection, {}), "\n", _jsxs(_components.p, {
      children: ["Повечето европейски езици имат граматичен род – английският е едно от малкото изключения. Не е повече от логично думите, обозначаващи лица от мъжки пол, винаги да са в мъжки род, а думите, обозначаващи лица от женски пол, винаги да са в женски род. Идеята за граматическия род обаче е, че ", _jsx(_components.em, {
        children: "всяко"
      }), " съществително име има род, дори и да няма никаква логическа връзка между този род и значението на думата. На френски например ", _jsxs(_components.span, {
        className: "notranslate",
        translate: "no",
        lang: "fr",
        children: ["l", _jsx(_components.strong, {
          children: "e"
        }), " vin"]
      }), " „виното” е от мъжки род, а ", _jsxs(_components.span, {
        className: "notranslate",
        translate: "no",
        lang: "fr",
        children: ["l", _jsx(_components.strong, {
          children: "a"
        }), " bière"]
      }), " „бирата” е от женски род. На немски ", _jsxs(_components.span, {
        className: "notranslate",
        translate: "no",
        lang: "de",
        children: [_jsx(_components.strong, {
          children: "der"
        }), " Wein"]
      }), " „виното” също е от мъжки род, но ", _jsxs(_components.span, {
        className: "notranslate",
        translate: "no",
        lang: "de",
        children: [_jsx(_components.strong, {
          children: "das"
        }), " Bier"]
      }), " „бирата” е от среден род. Родът на съществителното засяга не само члена, но и прилагателните, притежателните местоимения и други думи, които променят това съществително. Френският има ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        lang: "fr",
        children: "un bon vin froid"
      }), " „едно добро студено вино”, но ", _jsxs(_components.span, {
        className: "notranslate",
        translate: "no",
        lang: "fr",
        children: ["un", _jsx(_components.strong, {
          children: "e"
        }), " bon", _jsx(_components.strong, {
          children: "ne"
        }), " bière froid", _jsx(_components.strong, {
          children: "e"
        })]
      }), " „една добра студена бира”."]
    }), "\n", _jsxs(_components.p, {
      children: ["Всички славянски езици имат три рода: мъжки, женски и среден. На първо ниво на ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: "Slovianto"
      }), " полът не играе роля, защото не е от съществено значение за общуването на най-основното ниво. Малките деца често правят грешки с пола, но все пак могат да бъдат разбрани. Което не променя факта, че ", _jsx(TransliteratorElement, {
        children: "dobry žena"
      }), " „добра жена” звучи тромаво, защото ", _jsx(TransliteratorElement, {
        children: "žena"
      }), " е от женски род, а окончанието ", _jsx(_components.code, {
        children: "-y"
      }), " е от мъжки род. Можете да направите вашия ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: "Slovianto"
      }), " да изглежда и звучи много по-естествено, ако вземете предвид и пола. Установяването на рода на съществителното не е никак трудно, тъй като в почти всички случаи е достатъчно да се погледне думата, за да се разбере нейният род, което означава, че няма нужда да се научава родът отделно."]
    }), "\n", _jsx(_components.h3, {
      id: "съществителни",
      children: "Съществителни"
    }), "\n", _jsx(_components.p, {
      children: "За да разберете дали една дума е от мъжки, женски или среден род, е достатъчно да погледнете края:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "Думите от мъжки род винаги завършват на съгласна:"
        }), "\n", _jsxs(_components.ul, {
          children: ["\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "muž"
            }), " „човек”"]
          }), "\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "syn"
            }), " „син”"]
          }), "\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "dom"
            }), " „къща”"]
          }), "\n"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["Думите на ", _jsx(_components.code, {
            children: "-a"
          }), " са от женски род:"]
        }), "\n", _jsxs(_components.ul, {
          children: ["\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "žena"
            }), " „жена, съпруга”"]
          }), "\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "duša"
            }), " „душа”"]
          }), "\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "voda"
            }), " „вода”"]
          }), "\n"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["Думите на ", _jsx(_components.code, {
            children: "-o"
          }), " и ", _jsx(_components.code, {
            children: "-e"
          }), " са от среден род:"]
        }), "\n", _jsxs(_components.ul, {
          children: ["\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "slovo"
            }), " „дума“"]
          }), "\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "děte"
            }), " „дете”"]
          }), "\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "morje"
            }), " „море”"]
          }), "\n"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["Има и група думи от женски род, завършващи на съгласна. Като правило не забравяйте, че повечето от тези думи завършват на ", _jsx(_components.code, {
            children: "-ost"
          }), ":"]
        }), "\n", _jsxs(_components.ul, {
          children: ["\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "kost"
            }), " „кост”"]
          }), "\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "velikost"
            }), " „величие”"]
          }), "\n"]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.p, {
      children: "Има няколко изключения, но не е нужно да се притеснявате за тях на този етап."
    }), "\n", _jsxs(_components.p, {
      children: ["На първо ниво научихте, че окончанието за множествено число е ", _jsx(_components.code, {
        children: "-i"
      }), ". Това работи добре за съществителни от мъжки и женски род, но в случай на съществителни от среден род е по-добре вместо това да използвате ", _jsx(_components.code, {
        children: "-a"
      }), ":"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(TransliteratorElement, {
          children: "slovo"
        }), " → ", _jsx(TransliteratorElement, {
          children: "slova"
        }), " „думи”"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(TransliteratorElement, {
          children: "děte"
        }), " → ", _jsx(TransliteratorElement, {
          children: "děta"
        }), " „деца”"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(TransliteratorElement, {
          children: "morje"
        }), " → ", _jsx(TransliteratorElement, {
          children: "morja"
        }), " „морета”"]
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      id: "прилагателни",
      children: "Прилагателни"
    }), "\n", _jsxs(_components.p, {
      children: ["Не само съществителните имат род, същото важи и за прилагателните и подобни модификатори. Точно както във френския и немския, славянските езици имат ", _jsx(_components.em, {
        children: "съгласие между половете"
      }), ". Това означава, че когато съществително от мъжки род е придружено от прилагателно, това прилагателно приема мъжка форма, съществително от женски род приема женска форма на прилагателно и т.н. ", _jsx(TransliteratorElement, {
        children: "Dobry žena"
      }), " изглежда малко детински и тромаво, защото съчетава съществително от женски род с прилагателно от мъжки род. Така че запомнете следните неща:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["Окончанието в мъжки род е ", _jsx(_components.code, {
            children: "-y"
          }), " или ", _jsx(_components.code, {
            children: "-i"
          }), ". Това е формата, дадена в речника:"]
        }), "\n", _jsxs(_components.p, {
          children: [_jsx(TransliteratorElement, {
            children: "dobry muž"
          }), " „добър човек”"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["Окончанието в женски род е ", _jsx(_components.code, {
            children: "-a"
          }), ":"]
        }), "\n", _jsxs(_components.p, {
          children: [_jsx(TransliteratorElement, {
            children: "dobra žena"
          }), " „добра жена”"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["Среден род е ", _jsx(_components.code, {
            children: "-e"
          }), ":"]
        }), "\n", _jsxs(_components.p, {
          children: [_jsx(TransliteratorElement, {
            children: "dobre děte"
          }), " „добро дете”"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["За всички полове окончанието за множествено число е ", _jsx(_components.code, {
            children: "-e"
          }), ":"]
        }), "\n", _jsxs(_components.ul, {
          children: ["\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "dobre muži"
            }), " „добри мъже”"]
          }), "\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "dobre ženi"
            }), " „добра жена”"]
          }), "\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "dobre děta"
            }), " „добри деца”"]
          }), "\n"]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.p, {
      children: "Същото, което важи за прилагателните, важи и за притежателните, показателните, относителните, неопределителните местоимения, както и за числата."
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["Притежателните местоимения ", _jsx(TransliteratorElement, {
            children: "moj"
          }), " „мой”, ", _jsx(TransliteratorElement, {
            children: "tvoj"
          }), " „твой, твой”, ", _jsx(TransliteratorElement, {
            children: "naš"
          }), " „наш”, ", _jsx(TransliteratorElement, {
            children: "vaš"
          }), " „твой (", _jsx(_components.abbr, {
            title: "множествено число",
            children: "мн.ч."
          }), ")”, ", _jsx(TransliteratorElement, {
            children: "svoj"
          }), " „свой” и ", _jsx(TransliteratorElement, {
            children: "čij"
          }), " „чийто” получава същите окончания като прилагателните (освен в мъжки род): ", _jsx(TransliteratorElement, {
            children: "moj"
          }), " (", _jsx(_components.abbr, {
            title: "мъжки род",
            children: "м.р."
          }), "), ", _jsx(TransliteratorElement, {
            children: "moja"
          }), " (", _jsx(_components.abbr, {
            title: "женски род",
            children: "ж.р."
          }), "), ", _jsx(TransliteratorElement, {
            children: "moje"
          }), " (", _jsx(_components.abbr, {
            title: "среден род",
            children: "с.р."
          }), "), ", _jsx(TransliteratorElement, {
            children: "moje"
          }), " (", _jsx(_components.abbr, {
            title: "множествено число",
            children: "мн.ч."
          }), " ). Същото важи и за въпросителното местоимение ", _jsx(TransliteratorElement, {
            children: "koj"
          }), " „което”:"]
        }), "\n", _jsxs(_components.ul, {
          children: ["\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "moj muž"
            }), " „съпругът ми”"]
          }), "\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "tvoja žena"
            }), " „вашата жена”"]
          }), "\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "naše děte"
            }), " „нашето дете”"]
          }), "\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "koje prijatelji"
            }), " „кои приятели”"]
          }), "\n"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["Притежателните местоимения на трето лице (", _jsx(TransliteratorElement, {
            children: "jego"
          }), " „негов, негов”, ", _jsx(TransliteratorElement, {
            children: "jej"
          }), " „нейен”, ", _jsx(TransliteratorElement, {
            children: "jih"
          }), " „техен”) не се променят (това е така, защото тези думи не са строго притежателни местоимения, а буквално означават нещо като „от него“ и т.н.):"]
        }), "\n", _jsxs(_components.ul, {
          children: ["\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "jego žena"
            }), " „съпругата му”"]
          }), "\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "jih prijatelji"
            }), " „техните приятели”"]
          }), "\n"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["Указателното местоимение ", _jsx(TransliteratorElement, {
            children: "toj"
          }), " има формите ", _jsx(TransliteratorElement, {
            children: "ta"
          }), " (", _jsx(_components.abbr, {
            title: "женски род",
            children: "ж.р."
          }), "), ", _jsx(TransliteratorElement, {
            children: "to"
          }), " (", _jsx(_components.abbr, {
            title: "среден род",
            children: "с.р."
          }), ") и ", _jsx(TransliteratorElement, {
            children: "te"
          }), " (", _jsx(_components.abbr, {
            title: "множествено число",
            children: "мн.ч."
          }), "), вместо ", _jsxs(_components.em, {
            children: ["*", _jsx(TransliteratorElement, {
              children: "toja"
            }), ", *@@ 83..."]
          }), " (същото важи, разбира се, за ", _jsx(TransliteratorElement, {
            children: "tutoj"
          }), " и ", _jsx(TransliteratorElement, {
            children: "tamtoj"
          }), "):"]
        }), "\n", _jsxs(_components.ul, {
          children: ["\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "toj muž"
            }), " „този човек”"]
          }), "\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "ta žena"
            }), " „тази жена”"]
          }), "\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "to děte"
            }), " „това дете”"]
          }), "\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "te prijatelji"
            }), " „тези приятели”"]
          }), "\n"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["Относителното местоимение ", _jsx(TransliteratorElement, {
            children: "ktory"
          }), " се държи като прилагателно:"]
        }), "\n", _jsxs(_components.ul, {
          children: ["\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "žena, ktora čita"
            }), " „жена, която чете”"]
          }), "\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "děte, ktore ja viděl"
            }), " „детето, което съм виждал”"]
          }), "\n"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["Числото ", _jsx(TransliteratorElement, {
            children: "jedin"
          }), " „едно” има формата ", _jsx(TransliteratorElement, {
            children: "jedna"
          }), " (", _jsx(_components.abbr, {
            title: "женски род",
            children: "ж.р."
          }), ") и ", _jsx(TransliteratorElement, {
            children: "jedno"
          }), " (", _jsx(_components.abbr, {
            title: "среден род",
            children: "с.р."
          }), "):"]
        }), "\n", _jsxs(_components.ul, {
          children: ["\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "jedin muž"
            }), " „един човек”"]
          }), "\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "jedna žena"
            }), " „една жена”"]
          }), "\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "jedno děte"
            }), " „това дете”"]
          }), "\n"]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "глаголи",
      children: "Глаголи"
    }), "\n", _jsx(_components.h3, {
      id: "сегашно-време",
      children: "Сегашно време"
    }), "\n", _jsx(MDSimpleGrammar1, {}), "\n", _jsxs(_components.p, {
      children: ["В ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: "Slovianto"
      }), " ниво 1 научихте, че сегашното време се образува чрез добавяне на окончание ", _jsx(_components.code, {
        children: "-(e)t"
      }), " към основата: ", _jsx(TransliteratorElement, {
        children: "ja děla-t"
      }), " „правя“, ", _jsx(TransliteratorElement, {
        children: "vy prosi-t"
      }), " „питате“, ", _jsx(TransliteratorElement, {
        children: "oni nes-et"
      }), " „те носят“. За славянското ухо обаче това звучи неестествено, защото всички славянски езици склоняват глаголите си за лице и число. За да направите по-добро впечатление, можете да спечелите много, като научите и някои от тези лични окончания."]
    }), "\n", _jsxs(_components.p, {
      children: ["И така, време е да забравите края ", _jsx(_components.code, {
        children: "-t"
      }), "! Вместо това запомнете следните окончания: ", _jsx(_components.code, {
        children: "-m"
      }), ", ", _jsx(_components.code, {
        children: "-š"
      }), ", ", _jsx(_components.code, {
        children: "-Ø"
      }), "  (без край) в първо, второ и трето лице единствено число и ", _jsx(_components.code, {
        children: "-mo"
      }), ", ", _jsx(_components.code, {
        children: "-te"
      }), ", ", _jsx(_components.code, {
        children: "-ut"
      }), "  в първо, второ и трето лице множествено число. Когато основата завършва на гласна, вмъкнете ", _jsx(_components.code, {
        children: "-j-"
      }), " преди края ", _jsx(_components.code, {
        children: "-ut"
      }), ". Когато основата завършва на съгласна, вмъкнете ", _jsx(_components.code, {
        children: "-e-"
      }), " преди останалите окончания. Вижте таблицата вдясно за някои примери."]
    }), "\n", _jsxs(_components.p, {
      children: ["Окончанието ", _jsx(_components.code, {
        children: "-š"
      }), " и личното местоимение ", _jsx(TransliteratorElement, {
        children: "ty"
      }), " трябва да се използват само за семейство, приятели, деца и т.н. В други случаи се обръщайте към хората във второ лице множествено число (", _jsx(TransliteratorElement, {
        children: "vy"
      }), ", ", _jsx(_components.code, {
        children: "-te"
      }), ")."]
    }), "\n", _jsx(_components.h3, {
      id: "минало-време",
      children: "Минало време"
    }), "\n", _jsx(MDSimpleGrammar2, {}), "\n", _jsxs(_components.p, {
      children: ["В минало време глаголите не се спрягат по лице. Те обаче са спрегнати за пола. Това може да изглежда странно, но обяснението е доста просто: формата ", _jsx(TransliteratorElement, {
        children: "dělal"
      }), " всъщност е причастие, което означава нещо като „свършил“ и затова се съгласува с подлога по род и число, но не и по лице. Формулярите са показаните в таблицата вдясно."]
    }), "\n", _jsx(_components.h3, {
      id: "бъдеще-време",
      children: "Бъдеще време"
    }), "\n", _jsxs(_components.p, {
      children: ["Бъдещето време се образува чрез комбиниране на бъдеще време на глагола ", _jsx(TransliteratorElement, {
        children: "byti"
      }), " „to be” с инфинитив. Формите са същите, както ако глагол ", _jsx(TransliteratorElement, {
        children: "*bud-ti"
      }), " е спрегнат в сегашно време: ", _jsx(TransliteratorElement, {
        children: "ja budem dělati"
      }), ", ", _jsx(TransliteratorElement, {
        children: "ty budeš dělati"
      }), ", ", _jsx(TransliteratorElement, {
        children: "on bude dělati"
      }), ",  и т.н."]
    }), "\n", _jsx(_components.h3, {
      id: "условно",
      children: "Условно"
    }), "\n", _jsxs(_components.p, {
      children: ["Условното наклонение се формира чрез добавяне на частицата ", _jsx(TransliteratorElement, {
        children: "by"
      }), " към миналото време и следователно подлежи на съгласие по род: ", _jsx(TransliteratorElement, {
        children: "ja by dělal"
      }), " „Аз (", _jsx(_components.abbr, {
        title: "мъжки род",
        children: "м.р."
      }), ") бих направил/бях направил”, ", _jsx(TransliteratorElement, {
        children: "ty by dělala"
      }), " „ти (", _jsx(_components.abbr, {
        title: "женски род",
        children: "ж.р."
      }), ") бихме направили/бяхме направили”, ", _jsx(TransliteratorElement, {
        children: "my by dělali"
      }), " „щяхме да направим/бяхме направили”."]
    }), "\n", _jsx(_components.h3, {
      id: "задължително",
      children: "Задължително"
    }), "\n", _jsx(MDSimpleGrammar3, {}), "\n", _jsxs(_components.p, {
      children: ["Освен повелителната форма, която вече научихте (2-ро лице множествено число), има и повелителни форми за 2-ро лице единствено число и 1-во лице множествено число. Окончанията са ", _jsx(_components.code, {
        children: "-j"
      }), " (", _jsx(_components.abbr, {
        title: "2 sg.",
        children: "2 sg."
      }), "), ", _jsx(_components.code, {
        children: "-jmo"
      }), " (", _jsx(_components.abbr, {
        title: "1 pl.",
        children: "1 pl."
      }), ") и ", _jsx(_components.code, {
        children: "-jte"
      }), " (", _jsx(_components.abbr, {
        title: "2 pl.",
        children: "2 pl."
      }), ") след гласна и ", _jsx(_components.code, {
        children: "-i"
      }), " (", _jsx(_components.abbr, {
        title: "2 sg.",
        children: "2 sg."
      }), "), ", _jsx(_components.code, {
        children: "-imo"
      }), " (", _jsx(_components.abbr, {
        title: "1 pl.",
        children: "1 pl."
      }), " ) и ", _jsx(_components.code, {
        children: "-ite"
      }), " (", _jsx(_components.abbr, {
        title: "2 pl.",
        children: "2 pl."
      }), ") след съгласна. Така ", _jsx(TransliteratorElement, {
        children: "dělajte"
      }), " означава „направи!“ и може да бъде насочен към повече хора наведнъж, но също така служи като по-учтива форма за единствено число, докато ", _jsx(TransliteratorElement, {
        children: "dělaj"
      }), " трябва да се използва само за приятели, семейство и деца. ", _jsx(TransliteratorElement, {
        children: "Dělajmo"
      }), " означава: „Да направим”."]
    }), "\n", _jsx(_components.h3, {
      id: "глаголът-да-бъда",
      children: "Глаголът „да бъда“"
    }), "\n", _jsx(MDSimpleGrammar4, {}), "\n", _jsxs(_components.p, {
      children: ["Тъй като всичко по-горе засяга и единствения неправилен глагол в ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: "Slovianto"
      }), ", ", _jsx(TransliteratorElement, {
        children: "byti"
      }), "  „to be“, ето пълното му спрежение."]
    }), "\n", _jsx(_components.h2, {
      id: "примерен-текст",
      children: "Примерен текст"
    }), "\n", _jsxs(MDSimpleGrammar5, {
      children: [_jsx(_components.h3, {
        id: "нашето-село",
        children: "Нашето село"
      }), _jsx(_components.p, {
        children: "От всички възможни места, където живеят хора, това, което обичам най-много е малко селце, далеч от шума на града, с неговата малка общност. Няма пренаселени апартаменти, само малки дървени вили. Това е просто и живописно място за живеене, с жители, чиито лица са толкова познати, колкото цветята в нашата градина. Това е уединен свят с малко хора, тясно обединени като мравки в мравуняк, или пчели в кошер, или овце в кошара, или монахини в манастир, или моряци на кораб – където всеки познава всеки и всеки е познат от всички, където всеки се интересува от всеки и всеки може да се надява, че другите се интересуват от него."
      }), _jsx(_components.p, {
        children: "Колко приятно би било човек да се потопи в това сърдечно чувство на любов и непознати навици, да се събере и да бъде приятел с всички тези уникални хора около нас! Точно както ще познаваме всички ъгли и завои на сенчестите улици и слънчевите поляни, по които минаваме всеки ден. Малката социална група, която е селското общество, е това, на което поезията и прозата дължат най-много. Дълга, разтегната улица, криволичеща в хубав, топъл ден, пресичаща голям, широк път, пълен с коли и камиони. Искаш ли да пътуваш с мен, скъпи читателю? Пътуването няма да е дълго. Започваме от края на долината и от там ще продължим нагоре по хълма."
      })]
    }), "\n", _jsx(CustomAfterSection, {})]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}

